package org.example.project.screens_shared

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import org.example.project.enginetabular.TabularScreen
import org.example.project.enginetabular.loadWithTabularFilters
import org.example.project.manager.LumaticaApiManager
import org.example.project.utils.All

private val loginJournalJson = Json {
    ignoreUnknownKeys = true
    encodeDefaults = false
}

private suspend fun loadLoginJournal(): List<All> {
    val raw = runCatching { LumaticaApiManager.call("loginjournal") }.getOrDefault("")
    if (raw.isBlank()) return emptyList()
    return runCatching { loginJournalJson.decodeFromString<List<All>>(raw) }.getOrDefault(emptyList())
}

private suspend fun searchLoginJournal(filters: Map<String, String>): List<All> {
    val raw = loadWithTabularFilters("loginjournal/search", filters)
    return runCatching { loginJournalJson.decodeFromString<List<All>>(raw) }.getOrDefault(emptyList())
}

@Composable
fun SHAREDLoginauskunft() {
    val scope = rememberCoroutineScope()
    var timeline by remember { mutableStateOf<List<All>>(emptyList()) }

    val headers = listOf(
        "Personalnummer",
        "Vorname",
        "Nachname",
        "Status",
        "Datum",
        "Uhrzeit"
    )

    val data = timeline.map { item ->
        item.id to listOf(
            item.personalnummer.ifBlank { "-" },
            item.vorname.ifBlank { "-" },
            item.nachname.ifBlank { "-" },
            item.typ.ifBlank { "-" },
            item.datum.ifBlank { "-" },
            item.uhrzeit.ifBlank { "-" }
        )
    }

    TabularScreen(
        screenKey = "LoginJournal",
        rollenKey = "LoginJournal",
        title = "Login Journal",
        headers = headers,
        data = data,
        editable = false,
        includeMetadata = true,
        hardReadOnly = true,
        allowCreate = false,
        nonEditableCols = headers.toSet(),
        onSearchWithFilters = { filters ->
            scope.launch {
                timeline = searchLoginJournal(filters)
            }
        },
        onCommit = { }
    )
}
